import React from 'react';
import Hero from '../components/Hero';
import ServicesPreview from '../components/ServicesPreview';
import AboutPreview from '../components/AboutPreview';
import ContactCTA from '../components/ContactCTA';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <AboutPreview />
      <ServicesPreview />
      <ContactCTA />
    </div>
  );
};

export default Home;